import React from 'react';
import { useNavigate } from 'react-router-dom';
import Path from 'app/route/Path'

const InvalidClusterResult = ({ hasNiitaContract }) => {
  const navigate = useNavigate();

  const handleOnClick = () => {
    window.open('https://www.instagram.com/reel/DL3UydbTnAa/?igsh=MWtpMzY3dDFnamYwbg==', '_blank');
  }

  return (
    <>
      {/* Result Section */}
      <section className="w-full bg-white rounded-2xl p-6 shadow-floating border border-slate-200 relative overflow-hidden" id="result">
        <div className="absolute top-0 right-0 w-32 h-32 bg-slate-50 rounded-bl-[100px] -z-0 opacity-50"></div>
        <div className="relative z-10">
          <h2 className="text-xs font-bold text-slate-400 tracking-widest uppercase mb-1">Total Evaluation</h2>
          <h3 className="text-xl font-bold text-slate-800 mb-4">頭皮判定結果</h3>
          <div className="flex items-center gap-5 mb-5">
            <div className="relative">
              <div className="w-20 h-20 rounded-full border-4 border-white shadow-sm bg-slate-100 flex items-center justify-center">
                <span className="material-symbols-outlined text-slate-300 !text-4xl">person_off</span>
              </div>
              <div className="absolute bottom-0 right-0 bg-slate-400 w-5 h-5 rounded-full border-2 border-white flex items-center justify-center">
                <span className="material-symbols-outlined text-white !text-[12px]">priority_high</span>
              </div>
            </div>
            <div>
              <div className="text-sm text-slate-500 mb-1">総合評価</div>
              <div className="flex items-center gap-2">
                <span className="text-4xl font-bold text-slate-300">Error</span>
                <span className="bg-slate-100 text-slate-500 text-[10px] font-bold px-2 py-0.5 rounded border border-slate-200 self-center ml-1">判定不能</span>
              </div>
            </div>
          </div>
          <div className="bg-slate-50 rounded-lg p-4 border border-slate-100">
            <p className="text-sm font-bold text-slate-700 mb-2 flex items-center gap-1">
              <span className="material-symbols-outlined text-slate-400 !text-lg">info</span>
              判定不能
            </p>
            <p className="text-xs text-slate-600 leading-relaxed mb-3">
              頭皮判定ができませんでした。下記の理由が考えられます。再度採取をお願いします。
            </p>
            <ul className="text-[11px] text-slate-500 space-y-3 bg-white p-3 rounded border border-slate-100">
              <li className="flex items-start gap-2">
                <span className="text-slate-300 font-bold">•</span>
                <span>採取できている角層が全体的に少ない<br /><span className="text-[10px] text-slate-400">（頭皮が脂っぽい人は特にご注意ください）</span></span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-slate-300 font-bold">•</span>
                <span>テープの半分にしか角層が採取できていない<br /><span className="text-[10px] text-slate-400">（採取時にしっかりと頭皮に押し当てて角層採取してください）</span></span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-slate-300 font-bold">•</span>
                <span>テープの真ん中に角層が採取できていない<br /><span className="text-[10px] text-slate-400">（採取時にしっかりと頭皮に押し当てて角層採取してください）</span></span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Metrics Details Section */}
      <section className="w-full space-y-4" id="metrics">
        <h3 className="text-sm font-bold text-slate-400 px-1 uppercase tracking-wider">Metrics Details</h3>
        <div className="bg-white rounded-xl shadow-medical border border-slate-200 overflow-hidden opacity-80">
          <div className="bg-slate-50 px-4 py-2 border-b border-slate-200 flex justify-between items-center">
            <div className="flex items-center gap-2">
              <span className="bg-slate-200 text-slate-500 text-[10px] font-mono font-bold px-1.5 py-0.5 rounded">TO-01</span>
              <h4 className="text-sm font-bold text-slate-400">細胞面積 <span className="text-xs font-normal">(Turnover)</span></h4>
            </div>
            <span className="material-symbols-outlined text-slate-300 !text-lg">science</span>
          </div>
          <div className="p-8 flex flex-col items-center justify-center text-center">
            <span className="material-symbols-outlined text-slate-200 !text-5xl mb-2">query_stats</span>
            <p className="text-sm font-bold text-slate-400">測定不能</p>
            <p className="text-[10px] text-slate-300 mt-1">データ不足のため表示できません</p>
          </div>
        </div>
      </section>

      {/* Scalp Profile Section */}
      <section className="w-full bg-white rounded-xl p-5 shadow-medical border border-slate-200 relative opacity-80">
        <div className="flex justify-between items-start mb-4">
          <div>
            <h3 className="text-sm font-bold text-slate-400">Scalp Profile <span className="text-xs font-normal">（分析チャート）</span></h3>
          </div>
        </div>
        <div className="relative w-full aspect-square max-w-[180px] mx-auto mb-4 flex items-center justify-center">
          <svg className="w-full h-full opacity-20" viewBox="0 0 100 100">
            <polygon fill="#f1f5f9" points="50,10 90,80 10,80" stroke="#e2e8f0" strokeWidth="0.5" />
            <line stroke="#e2e8f0" strokeWidth="0.5" x1="50" x2="50" y1="50" y2="10" />
            <line stroke="#e2e8f0" strokeWidth="0.5" x1="50" x2="90" y1="50" y2="80" />
            <line stroke="#e2e8f0" strokeWidth="0.5" x1="50" x2="10" y1="50" y2="80" />
          </svg>
          <div className="absolute inset-0 flex items-center justify-center">
            <p className="text-[10px] font-bold text-slate-400 bg-white/80 px-2 py-1 rounded">データ不足</p>
          </div>
        </div>
      </section>

      {/* AI Advice Section */}
      {hasNiitaContract && (
        <section className="space-y-4" id="ai-advice">
          <div className="flex items-center gap-2 mb-2 px-1">
            <span className="material-symbols-outlined text-slate-300 !text-2xl">psychology</span>
            <h3 className="text-lg font-bold text-slate-400">Niitaによるアドバイス</h3>
          </div>
          <div className="bg-white rounded-xl shadow-medical border border-slate-200 overflow-hidden">
            <div className="bg-slate-50 px-4 py-3 border-b border-slate-100">
              <h4 className="text-sm font-bold text-slate-500 flex items-center gap-2">
                <span className="material-symbols-outlined !text-lg">info</span>
                GUIDANCE <span className="text-xs font-normal ml-1">（再採取のご案内）</span>
              </h4>
            </div>
            <div className="p-6 text-center">
              <p className="text-sm leading-relaxed text-slate-600 mb-6">
                解析に必要なデータが不足しているため、現在は詳細なアドバイスを表示することができません。正確な診断のために、ガイドに沿ってもう一度サンプルを採取してください。
              </p>
              <div className="flex flex-col gap-3">
                <button className="w-full bg-slate-50 border border-slate-200 text-slate-700 text-xs font-bold py-3 rounded-lg hover:bg-slate-100 transition"
                onClick={handleOnClick}
                >
                  正しい採取の手順を動画で見る
                </button>
                <button className="w-full bg-slate-800 text-white text-xs font-bold py-3 rounded-lg shadow-sm"
                  onClick={() => navigate(Path.orderScalpLab)}
                >
                  新しい検体を登録する
                </button>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Footer Note */}
      <div className="px-2 pt-8 pb-4">
        <p className="text-[10px] text-slate-400 leading-relaxed text-center bg-slate-50 p-3 rounded border border-slate-100">
          判定不能となった場合は、お手数ですが再度検体をお送りください。<br />
          ご不明な点はサポートセンターまでお問い合わせください。
        </p>
      </div>
    </>
  );
}

export default InvalidClusterResult;
